var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenStepCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 17,
    viewBox: "0 0 33 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.721191 0H27.1919L32.7302 8.43145L27.1919 16.8629H0.721191L6.2595 8.43145L0.721191 0Z",
    fill: "#2CDB3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStepCompleted);
export default __webpack_public_path__ + "static/media/greenStepCompleted.49f2b676af330ce2e5481a5dc8dafd35.svg";
export { ForwardRef as ReactComponent };